/**
 *
 * FlexibleScheduleTripBadge
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import { COLORS } from 'theme';
import TimeSpanIcon from 'assets/v2/TimeSpanIcon';
import Badge from '..';

const StyledBadge = styled(Badge)`
  &.MuiChip-root {
    color: ${COLORS.ecruDark};
    background: ${COLORS.ecruLight};
    border-color: ${COLORS.ecru};
  }

  && .MuiSvgIcon-root {
    path {
      fill: ${COLORS.ecru};
    }
  }
`;

function FlexibleScheduleTripBadge(props) {
  return (
    <StyledBadge
      icon={<TimeSpanIcon />}
      size="iconLarge"
      variant="outlined"
      {...props}
    />
  );
}

export default memo(FlexibleScheduleTripBadge);
